<template>
  <div v-if="!isHidden" class="top-select">
      <div class="page-column-name">{{ newTitle }}</div>
      <jd-tab
        v-model="activeName"
        :tabsList="list"
        :fatherTabAct="activeName"
        @input="handleClick"
        :showIcon="true"
        class="tab-box-style"
      />
  </div>
</template>

<script>
export default {
  props:{
    list:{
      type:Array,
      default:()=>[]
    },
    title:{
      type:String,
      default:''
    }
  },
  data(){
    return {
      activeName:null,
      isHidden: false,
      newTitle: "",
    }
  },
  watch:{
    list:{
      handler:function(val){
        this.isHidden = val.some(item => item.path == 'marketing_model'||item.path =='daily_operations'||item.path =='big_promotion_marketing'||item.path=='interactiveSquare');
        if(val.length){
          const path = this.$route.path
          const paths = val.map(route=>route.jumpUrl)
          if(!paths.includes(path)){
            this.activeName = paths[0]
            this.handleClick()
          }else{
            this.activeName = path
          }
        }
      },
      immediate:true
    },
    // 相同菜单下切换子菜单
    $route(val){
      this.activeName = val.path
    },
    title:{
      handler(val){
        if(val) {
          this.newTitle = val
        }
      },
      immediate:true
    },
  },
  methods:{
    handleClick(){
      this.$router.push(this.activeName)
    }
  }
}
</script>

<style lang="scss" scoped>
.top-select{
  padding: 16px 16px 0 16px;
  background: #FFFFFF;
  border-radius: 8px 8px 0px 0px;
  font-family: 'PingFang SC';
  .tab-box-style {
    height: 42px;
    line-height: 42px;
  }
}
// ::v-deep{
//   .el-tabs__item{
//     font-size:$main-size !important;
//     padding: 0px;
//     color: #666666;
//     height: 42px;
//     line-height: 42px;
//     font-family: 'PingFang SC';
//   }
//   .el-tabs__item.is-active .top-select-label{
//     // background-color: #E2EBFF;
//     color: #3159FF;
//     font-weight: 600;
//   }
//   .el-tabs__active-bar{
//     background-color: #3159FF;
//   }
//   .el-tabs__item + .el-tabs__item {
//     padding-left: 46px;
//   }
// }
</style>